<template>
    <div id="app">
        <div class="wx-pages">
            <router-view />
        </div>
    </div>
</template>

<script>

export default {
    name: 'App',
    data: {
    },
    created() {
    },
    mounted() {
        this.noPullDown();
    },
    methods: {
        noPullDown() {
            const overscroll = function (el) {
                el.addEventListener('touchstart', function () {
                    const top = el.scrollTop;
                    const totalScroll = el.scrollHeight;
                    const curScroll = top + el.offsetHeight;
                    if (top == 0) {
                        el.scrollTop = 1;
                    } else if (curScroll == totalScroll) {
                        el.scrollTop = top - 1;
                    }
                });

                el.addEventListener('touchmove', function (evt) {
                    if (el.offsetHeight < el.scrollHeight) {
                        evt._isScroller = true;
                    }
                });
            };
            overscroll(document.querySelector('#app'));
            document.body.addEventListener('touchmove', function (evt) {
                console.log('evt._isScroller', evt._isScroller);
                if (!evt._isScroller) {
                    evt.preventDefault();
                }
            }, { passive: false });
        }
    }
};
</script>

<style lang="less">
@import './styles/common.less';

#app {
    text-align: left;
    height: 100vh;
    -webkit-overflow-scrolling: touch;
    padding: 0;
    margin: 0;
}

html,
body {
    margin: 0;
    padding: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, "PingFang SC", "Microsoft YaHei", "Noto Sans", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.robot-avatar {
    width: 32px;
    height: 32px;
    margin-top: 5px;
    border-radius: 32px;
    vertical-align: middle;
    margin-right: 10px;
}

a {
    color: var(--color-primary-normal);
}

.wx-pages {
    min-height: calc(100%+1px);
}
</style>



// WEBPACK FOOTER //
// src/App.vue